import React, { useState } from "react";
import { useParams } from "react-router";

import ReleasePreview from "./ReleasePreview";
import { SingleTeam } from "../../../features/team-single/SingleTeam";

import { CategoryState } from "../../../utils/CategoryState";
import { RequestState } from "../../../utils/RequestState";
import {
  useApproveTeam,
  useGetTeamMembers,
  useGetTeamsAdmin,
} from "../../../utils/useTeam";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

type Props = {
  isSelect: boolean;
};

export const ReleaseTeamPreviewContainer: React.FC<Props> = ({ isSelect }) => {
  const { id } = useParams<{ id: string }>();

  const [activeModal, setActiveModal] = useState<CategoryState>(
    CategoryState.None
  );
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Pending
  );
  const [message, setMessage] = useState<string>("");

  const auth_token = useAppSelector(getAuthToken);

  const queryArgs = {
    auth_token,
    is_jikei_request: !isSelect,
    id,
  };

  const {
    items: { teams },
    isLoading,
  } = useGetTeamsAdmin(queryArgs);
  const team = teams[0];

  const { members: teamMembers } = useGetTeamMembers({ id });

  const { mutateAsync, mutateLoading } = useApproveTeam([
    "teamAdmin",
    queryArgs,
  ]);

  const handleInputChange = (value: string) => {
    setMessage(value);
  };

  const showModal = (modal: CategoryState) => {
    setActiveModal(modal);
  };

  const closeModal = () => {
    setActiveModal(CategoryState.None);
    setRequestState(RequestState.Pending);
  };

  const handleSubmit = async (approve: boolean) => {
    if (auth_token && id) {
      setRequestState(RequestState.Doing);

      await mutateAsync({
        auth_token: auth_token,
        is_jikei_request: !isSelect,
        id: id,
        message: message,
        approve: approve,
      });

      setRequestState(RequestState.Success);
    }
  };

  return (
    <ReleasePreview
      message={message}
      targetName={`${team?.name} / ${team?.kana ? team.kana : ""} `}
      modalLink={`/team/${id}`}
      activeModal={activeModal}
      requestState={requestState}
      closeModal={closeModal}
      showModal={showModal}
      handleSubmit={handleSubmit}
      handleInputChange={handleInputChange}
      isLoading={isLoading || mutateLoading}
      releaseType={`チーム名 / ふりがな`}
    >
      <SingleTeam
        id={team?.id}
        team_members={teamMembers}
        name={team?.name}
        kana={team?.kana}
        description={team?.description}
        img={team?.term?.img}
        color={team?.term?.color}
        sns={team?.sns}
        owner={team?.owner}
        game={team?.game}
      />
    </ReleasePreview>
  );
};
